import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

interface CustomLinkProps {
  href: string;
  text: string;
  margin?: string;
}

export default function CustomLink({
  href,
  text,
  margin = "mt-0",
}: CustomLinkProps) {
  return (
    <Link
      to={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`leading-[28px] transition-all duration-300 text-[15px] text-[#6e798b] font-[400] hover:text-[#fff] flex items-center gap-1 ${margin}`}
    >
      {text}
      <ExternalLink size={14} />
    </Link>
  );
}
